// Optimized: Use requestIdleCallback for non-critical initialization, batch DOM operations
(function() {
    'use strict';
    
    // Early return for desktop (avoid unnecessary work)
    if (window.innerWidth > 767) return;
    
    function initToggleHeaders() {
        // Cache selector result to avoid repeated queries
        const headers = document.querySelectorAll(".v-stack.gap-4.sm\\:gap-5 p");
        if (headers.length === 0) return;
        
        // Batch all DOM operations
        const headerData = [];
        
        // First pass: collect data and prepare elements
        headers.forEach(header => {
            const icon = document.createElement("span");
            icon.textContent = " +";
            icon.style.marginLeft = "8px";
            
            const ul = header.nextElementSibling;
            if (ul && ul.tagName === "UL") {
                // Batch all style writes together
                ul.style.cssText = "max-height: 0; overflow: hidden; transition: max-height 0.3s ease-out, padding 0.3s ease-out; padding-top: 0; margin-bottom: 0;";
                
                headerData.push({ header, icon, ul });
            }
        });
        
        // Second pass: append icons and attach listeners (batched)
        headerData.forEach(function(data) {
            data.header.appendChild(data.icon);
            
            data.header.addEventListener("click", function() {
                const isOpen = data.ul.style.maxHeight !== "0px" && data.ul.style.maxHeight !== "0";
                
                // Use requestAnimationFrame to batch style reads/writes and prevent forced reflows
                requestAnimationFrame(function() {
                    if (!isOpen) {
                        // Batch all style reads before writes
                        const scrollHeight = data.ul.scrollHeight;
                        data.ul.style.cssText = "max-height: " + scrollHeight + "px; overflow: hidden; transition: max-height 0.3s ease-out, padding 0.3s ease-out; padding-top: 8px; margin-bottom: 20px;";
                        data.icon.textContent = " -";
                    } else {
                        data.ul.style.cssText = "max-height: 0; overflow: hidden; transition: max-height 0.3s ease-out, padding 0.3s ease-out; padding-top: 0; margin-bottom: 0;";
                        data.icon.textContent = " +";
                    }
                });
            }, { passive: true });
        });
    }
    
    // Use requestIdleCallback for non-critical initialization
    if (document.readyState === 'loading') {
        document.addEventListener("DOMContentLoaded", function() {
            if (window.requestIdleCallback) {
                requestIdleCallback(initToggleHeaders, { timeout: 1000 });
            } else {
                setTimeout(initToggleHeaders, 100);
            }
        });
    } else {
        // DOM already loaded
        if (window.requestIdleCallback) {
            requestIdleCallback(initToggleHeaders, { timeout: 1000 });
        } else {
            setTimeout(initToggleHeaders, 100);
        }
    }
})();

